import React, { useEffect } from 'react';
import katiba_logo_footer from '../assets/logo/katiba_logo_footer.png';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { FaMapMarkerAlt, FaFacebookF, FaTwitter, FaInstagram, FaYoutube, FaLinkedin } from 'react-icons/fa';
const Footer = () => {
    const { t } = useTranslation();
    const tr = (key) => {
        return t(`footer:${key}`);
    };

    const handleScreenSize = () => {
        const width = window.innerWidth;
        let screenSize;

        if (width >= 1536) {
            screenSize = '2xl';
        } else if (width >= 1280) {
            screenSize = 'xl';
        } else if (width >= 1024) {
            screenSize = 'lg';
        } else if (width >= 768) {
            screenSize = 'md';
        } else if (width >= 640) {
            screenSize = 'sm';
        } else {
            screenSize = 'xs'; // Extra small (default)
        }

       
    };

    useEffect(() => {
        window.addEventListener('resize', handleScreenSize);
        return () => {
            window.removeEventListener('resize', handleScreenSize);
        };
    }, []);

    return (
        <footer className={clsx('pb-4', 'bg-white dark:bg-gray-800', 'mt-6')}>
            {/* Social Media Icons */}
            <div className="grid grid-cols-12  mb-8 text-2xl items-center gap-2 bg-[#50A1CA] dark:bg-gray-900 py-12">
                {/* Say Hello Section */}
                <div className="col-span-12 px-4 sm:px-6 md:px-12 lg:px-24 xl:px-32 2xl:px-64">
                    <div className="col-span-12 flex items-center gap-2 mb-4">
                        <h1 className="text-white text-2xl font-bold mb-4">{tr('hello')}</h1>
                    </div>
                    <div className="col-span-12 flex items-center justify-center gap-4">
                        <NavLink to="https://www.facebook.com/humanrightstz" target="_blank" className="bg-white dark:bg-gray-800 rounded-md p-1">
                            <FaFacebookF className="text-[#50A1CA] dark:text-gray-400 font-bold text-xl" />
                        </NavLink>
                        <NavLink to="https://www.twitter.com/humanrightstz" target="_blank" className="bg-white dark:bg-gray-800 rounded-md p-1">
                            <FaTwitter className="text-[#50A1CA] dark:text-gray-400 font-bold text-xl" />
                        </NavLink>
                        <NavLink to="https://www.linkedin.com/humanrightstz" target="_blank" className="bg-white dark:bg-gray-800 rounded-md p-1">
                            <FaLinkedin className="text-[#50A1CA] dark:text-gray-400 font-bold text-xl" />
                        </NavLink>
                        <NavLink to="https://instagram.com/humanrightstz" target="_blank" className="bg-white dark:bg-gray-800 rounded-md p-1">
                            <FaInstagram className="text-[#50A1CA] dark:text-gray-400 font-bold text-xl" />
                        </NavLink>
                        <NavLink to="https://instagram.com/humanrightstz" target="_blank" className="text-white dark:text-gray-200 text-sm mr-2">
                            @humanrights
                        </NavLink>
                        <NavLink to="https://www.youtube.com/@hakitv1216" target="_blank" className="bg-white dark:bg-gray-800 rounded-md p-1">
                            <FaYoutube className="text-[#50A1CA] dark:text-gray-400 font-bold text-xl" />
                        </NavLink>
                        <NavLink to="https://www.youtube.com/@hakitv1216" target="_blank" className="text-white dark:text-gray-200 text-sm mr-2">
                            @hakiTV
                        </NavLink>
                    </div>
                </div>
            </div>
            <div className="grid grid-cols-12 px-4 sm:px-6 md:px-12 lg:px-24 xl:px-32 2xl:px-64">
                {/* Address Heading */}
                <div className="col-span-12 mb-8 text-2xl flex items-center gap-2">
                    <div className="flex items-center gap-2">
                        <div className="bg-[#50A1CA] rounded-md flex items-center p-2 justify-center">
                            <FaMapMarkerAlt className="text-white dark:text-gray-200 font-bold" />
                        </div>
                        <h2 className="text-[#50A1CA] font-bold">{tr('addressHeading')}</h2>
                    </div>
                </div>
                {/* Head quarter address */}
                <div className="col-span-3 sm:col-span-6 xs:col-span-12 xs:text-center sm:mt-4 xs:mt-4">
                    <nav className="flex flex-col">
                        <NavLink to="https://humanrights.or.tz/" target="_blank" className="text-gray-500 dark:text-gray-200 font-bold mb-4">
                            {tr('HQ')}
                        </NavLink>
                        <span className="text-gray-400 dark:text-gray-200 italic">{tr('HQHouse')}</span>
                        <span className="text-gray-400 dark:text-gray-200 italic">{tr('hqBlock')}</span>
                        <span className="text-gray-400 dark:text-gray-200 italic">{tr('HQAddress')}</span>
                        <span className="text-gray-400 dark:text-gray-200 italic">{tr('HQRegion')}</span>
                        <a href={`tel:${tr('HQTel')}`} className="text-gray-400 dark:text-gray-200 italic hover:underline">
                            {tr('HQTel')}
                        </a>
                    </nav>
                </div>
                {/* Arusha office address */}
                <div className="col-span-3 sm:col-span-6 xs:col-span-12 xs:text-center sm:mt-4 xs:mt-4">
                    <nav className="flex flex-col">
                        <NavLink to="https://humanrights.or.tz/" target="_blank" className="text-gray-500 dark:text-gray-200 font-bold mb-4">
                            {tr('arusha')}
                        </NavLink>
                        <span className="text-gray-400 dark:text-gray-200 italic">{tr('arushaHouse')}</span>
                        <span className="text-gray-400 dark:text-gray-200 italic">{tr('arushaBlock')}</span>
                        <span className="text-gray-400 dark:text-gray-200 italic">{tr('arushaAddress')}</span>
                        <span className="text-gray-400 dark:text-gray-200 italic">{tr('arushaRegion')}</span>
                        <a href={`tel:${tr('arushaTel1')}`} className="text-gray-400 dark:text-gray-200 italic hover:underline">
                            {tr('arushaTel1')}
                        </a>
                        <a href={`tel:${tr('arushaTel2')}`} className="text-gray-400 dark:text-gray-200 italic hover:underline">
                            {tr('arushaTel2')}
                        </a>
                    </nav>
                </div>
                {/* Kinondoni office address */}
                <div className="col-span-3 sm:col-span-6 xs:col-span-12 xs:text-center sm:mt-4 xs:mt-4">
                    <nav className="flex flex-col">
                        <NavLink to="https://humanrights.or.tz/" target="_blank" className="text-gray-500 dark:text-gray-200 font-bold mb-4">
                            {tr('kinondoni')}
                        </NavLink>
                        <span className="text-gray-400 dark:text-gray-200 italic">{tr('kinondoniHouse')}</span>
                        <span className="text-gray-400 dark:text-gray-200 italic">{tr('kinondoniBlock')}</span>
                        <span className="text-gray-400 dark:text-gray-200 italic">{tr('kinondoniAddress')}</span>
                        <span className="text-gray-400 dark:text-gray-200 italic">{tr('kinondoniRegion')}</span>
                        <a href={`tel:${tr('kinondoniTel1')}`} className="text-gray-400 dark:text-gray-200 italic hover:underline">
                            {tr('kinondoniTel1')}
                        </a>
                    </nav>
                </div>
                {/* Dodoma office address */}
                <div className="col-span-3 sm:col-span-6 xs:col-span-12 xs:text-center sm:mt-4 xs:mt-4">
                    <nav className="flex flex-col">
                        <NavLink to="https://humanrights.or.tz/" target="_blank" className="text-gray-500 dark:text-gray-200 font-bold mb-4">
                            {tr('dodoma')}
                        </NavLink>
                        <span className="text-gray-400 dark:text-gray-200 italic">{tr('dodomaBlock')}</span>
                        <span className="text-gray-400 dark:text-gray-200 italic">{tr('dodomaAddress')}</span>
                        <span className="text-gray-400 dark:text-gray-200 italic">{tr('dodomaRegion')}</span>
                        <a href={`tel:${tr('dodomaTel1')}`} className="text-gray-400 dark:text-gray-200 italic hover:underline">
                            {tr('dodomaTel1')}
                        </a>
                        <a href={`tel:${tr('dodomaTel2')}`} className="text-gray-400 dark:text-gray-200 italic hover:underline">
                            {tr('dodomaTel2')}
                        </a>
                    </nav>
                </div>
            </div>
            {/* Full-Width Image */}
            <div className="col-span-12">
                <img src={katiba_logo_footer} alt="logo" className="w-full h-auto" />
            </div>
            {/* Bottom Footer */}
            <div className="col-span-12 font-bold py-4 lg:py-5 flex items-center justify-center text-gray-600 dark:text-gray-200 text-base lg:text-lg px-4 lg:px-12">
                <p className="text-center lg:text-left">{'© ' + new Date().getFullYear() + ' ' + tr('lhrc')}</p>
            </div>
        </footer>
    );
};

export default Footer;
